import { render, staticRenderFns } from "./activityAdd.vue?vue&type=template&id=220a7e85&scoped=true"
import script from "./activityAdd.vue?vue&type=script&lang=js"
export * from "./activityAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220a7e85",
  null
  
)

export default component.exports